<template>
  <div class="text-center">
    <v-menu
      v-model="notification"
      :close-on-content-click="false"
      offset-y
      offset-x
      origin="center center"
      :nudge-right="300"
      :nudge-bottom="2"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-badge
          :content="notiCount"
          :value="notiCount"
          color="green"
          v-on="on"
          overlap
        >
          <v-avatar v-bind="attrs" v-on="on" size="32px" item>
            <v-icon>mdi-bell</v-icon>
          </v-avatar>
        </v-badge>
      </template>
      <v-card
        height="370px"
        width="210px"
        left="-95px"
        top="-171px"
        border-radius="10px"
      >
        <v-card-text
          height="23px"
          width="104px"
          left="-79px"
          top="-167px"
          font-weight="400"
          border-radius="nullpx"
        >
          <h3>Notification</h3>
          <v-btn
            v-if="allNotificationView"
            class="blue--text"
            height="13px"
            width="20px"
            border-radius="8px"
            @click="getAllNotification()"
            ><h5>All</h5>
          </v-btn>
          <v-btn
            v-else
            height="13px"
            width="27px"
            border-radius="8px"
            @click="getAllNotification()"
            ><h5>All</h5>
          </v-btn>

          <v-btn
            v-if="unreadNotificationView"
            class="blue--text"
            @click="getUnreadNotification()"
            height="13px"
            width="35px"
            border-radius="8px"
            ><h5>Unread</h5></v-btn
          >
          <v-btn
            v-else
            @click="getUnreadNotification()"
            height="13px"
            width="35px"
            border-radius="8px"
            ><h5>Unread</h5></v-btn
          >
        </v-card-text>

        <v-card-text v-if="notification_data.length > 0" class="pa-0">
          <v-list v-for="(item, key) in notification_data" v-bind:key="key">
            <v-list-item
              v-if="item.is_seen != true"
              @click="changeVisibility(key)"
            >
              <v-list-item-content>
                <v-list-item-title
                  v-html="item.type"
                  class="font-weight-black"
                ></v-list-item-title>
                <p style="color: #212121">{{ item.message }}</p>
                <v-list-item-subtitle
                  style="color: #4267b2"
                  v-html="item.created_at"
                ></v-list-item-subtitle>
                <v-list-item-subtitle v-if="getVisibility(key)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="red"
                        v-bind="attrs"
                        v-on="on"
                        @click="RemoveNotification(item.id)"
                      >
                        <v-icon small> mdi-close </v-icon>
                      </v-btn>
                    </template>
                    <span>Remove this notification</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="SetMarkAsRead(item.id)"
                      >
                        <v-icon small> mdi-check-bold </v-icon>
                      </v-btn>
                    </template>
                    <span>Mark as Read</span>
                  </v-tooltip>
                </v-list-item-subtitle>

                <v-divider></v-divider>
              </v-list-item-content>
              <v-icon class="iconPM" color="primary" dense>mdi-circle</v-icon>
            </v-list-item>

            <v-list-item
              v-else-if="getReadStatus()"
              @click="changeVisibility(key)"
            >
              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-black"
                  style="color: #bdbdbd"
                  v-html="item.type"
                ></v-list-item-title>
                <p style="color: #bdbdbd">{{ item.message }}</p>
                <v-list-item-subtitle
                  style="color: #bdbdbd"
                  v-html="item.created_at"
                ></v-list-item-subtitle>
                <v-list-item-subtitle v-if="getVisibility(key)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="red"
                        v-bind="attrs"
                        v-on="on"
                        @click="RemoveNotification(item.id)"
                      >
                        <v-icon small> mdi-close </v-icon>
                      </v-btn>
                    </template>
                    <span>Remove this notification</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-divider></v-divider>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-card-text v-else>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Notification Not Found.</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex';
const moment = require('moment');
import axios from '@/plugins/axios';
import _ from 'lodash';
export default {
  data: () => ({
    notification: '',
    seendata: [],
    notification_data: [],

    allNotificationView: true,
    unreadNotificationView: false,
    visibility: {
      key: null,
      status: false,
    },
    //buttonchange: false,
    // read: true,
    // open:true,
    // close:true,
  }),
  computed: {
    ...mapState({
      Notification: (state) => state.common.notification,
    }),
    notiCount: function () {
      let count = 0;
      this.Notification.map((i) => {
        if (i.is_seen == false) {
          count++;
        }
      });
      return count;
    },
  },
  methods: {
    RemoveNotification(id) {
      this.$store
        .dispatch('common/RemoveNotification', id)
        .then((res) => {
          this.$toast.success('Notification successfully removed');
          this.getAllNotificationData();
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error('Failed to remove notification');
        });
      this.getAllNotificationData();
    },
    SetMarkAsRead(id) {
      this.$store
        .dispatch('common/ReadNotification', id)
        .then((resp) => {
          this.$toast.success('Notification mark as read');
          this.getAllNotificationData();
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error('Failed to mark notification as read');
        });
    },

    changeVisibility(key) {
      this.visibility.key = key;
      this.visibility.status = true;
    },
    getVisibility(key) {
      if (this.visibility.key == key) {
        return this.visibility.status;
      } else {
        return false;
      }
    },
    getReadStatus() {
      if (this.allNotificationView == true) {
        return true;
      } else {
        return false;
      }
    },
    getAllNotification() {
      this.unreadNotificationView = false;
      this.allNotificationView = true;
    },
    getUnreadNotification() {
      this.allNotificationView = false;
      this.unreadNotificationView = true;
    },

    readAll() {
      axios
        .post(`notifications/all-read`)
        .then((resp) => {
          this.seendata = resp.status;
        })
        .catch((err) => {
          reject(err.response);
        });
    },
    // buttoncheange() {
    //
    //   this.buttonchange = true;
    //   this.read = false;
    // },

    getAllNotificationData() {
      this.$store.dispatch('common/notifications').then((res) => {
        this.notification_data = res;
      });
    },
    view(item) {
      this.$store.dispatch('common/notifications').then(() => {
        localStorage.setItem('id', item.model_index);
        axios
          .post(`notifications/${item.id}/read`)
          .then((resp) => {
            this.$router.push('/cheque');
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
  },
  created() {
    this.getAllNotificationData();
  },
};
</script>

<style scoped>
.iconPM {
  width: 16px;
  height: 16px;
  border: none;
  display: inline-block;

  animation: blink 2s ease-in infinite;
}

@keyframes blink {
  from,
  to {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
</style>
